<template>
    <g fill-rule="evenodd">
        <path d="M21 12.024c0 .854-.665 1.567-1.52 1.567h-5.89v5.89c0 .854-.712 1.519-1.566 1.519-.855 0-1.567-.665-1.567-1.52v-5.89h-5.89C3.712 13.59 3 12.879 3 12.025c0-.855.712-1.567 1.567-1.567h5.89v-5.89c0-.855.712-1.567 1.567-1.567.427 0 .819.178 1.104.463.285.285.463.677.463 1.104v5.89h5.89c.854 0 1.519.712 1.519 1.567z" transform="translate(-752 -473) translate(749 470)"/>
    </g>
</template>

<script>
export default {
    name: 'plusBoldIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 18 18');
    }
};
</script>
